/**
 * Types generales para leads de SF
 */
export const SET_TRATAMIENTO = "SET_TRATAMIENTO";
export const SET_NOMBRE = "SET_NOMBRE"
export const SET_APELLIDO_MATERNO = "SET_APELLIDO_MATERNO"
export const SET_APELIIDO_PATERNO = "SET_APELIIDO_PATERNO"
export const SET_ESTADO = "SET_ESTADO"
export const SET_CIUDAD = "SET_CIUDAD"
export const SET_ID_CONCESIONARIO = "SET_ID_CONCESIONARIO"
export const SET_CONCESIONARIO = "SET_CONCESIONARIO"
export const SET_TELEFONO = "SET_TELEFONO"
export const SET_MOVIL = "SET_MOVIL"
export const SET_CORREO = "SET_CORREO"
export const SET_COMENTARIOS = "SET_COMENTARIOS"
export const SET_SEXO = "SET_SEXO"
export const SET_AVISO_PRIVACIDAD = "SET_AVISO_PRIVACIDAD"
export const SET_TERMINOS_Y_CONDICIONES = "SET_TERMINOS_Y_CONDICIONES"
export const SET_TRANSFERENCIA_DE_DATOS = "SET_TRANSFERENCIA_DE_DATOS"
export const SET_CONTACO_MARKETING = "SET_CONTACO_MARKETING"
export const SET_VEIHICULO = "SET_VEIHICULO"
export const SET_TIPO_CITA = "SET_TIPO_CITA"
export const SET_NOMBRE_DEL_VEHICULO = "SET_NOMBRE_DEL_VEHICULO"
export const RESET_STATE = "RESET_STATE"


/**
 * Types para el request de Citas de servicio
 */
export const SET_NOMBRE_CITAS_SERVICIO = "SET_NOMBRE_CITAS_SERVICIO";
export const SET_APELLIDO_MATERNO_CITAS_SERVICIO = "SET_APELLIDO_MATERNO_CITAS_SERVICIO";
export const SET_APELIIDO_PATERNO_CITAS_SERVICIO = "SET_APELIIDO_PATERNO_CITAS_SERVICIO";
export const SET_ESTADO_CITAS_SERVICIO = "SET_ESTADO_CITAS_SERVICIO";
export const SET_ID_CONCESIONARIO_CITAS_SERVICIO = "SET_ID_CONCESIONARIO_CITAS_SERVICIO";
export const SET_CONCESIONARIO_CITAS_SERVICIO = "SET_CONCESIONARIO_CITAS_SERVICIO";
export const SET_TELEFONO_CITAS_SERVICIO = "SET_TELEFONO_CITAS_SERVICIO";
export const SET_CORREO_CITAS_SERVICIO = "SET_CORREO_CITAS_SERVICIO";
export const SET_FECHA_CITA_CITAS_SERVICIO = "SET_FECHA_CITA_CITAS_SERVICIO";
export const SET_HORARIO_CITA_CITAS_SERVICIO = "SET_HORARIO_CITA_CITAS_SERVICIO";
export const SET_MODELO_AUTO_CITAS_SERVICIO = "SET_MODELO_AUTO_CITAS_SERVICIO";
export const SET_YEAR_AUTO_CITAS_SERVICIO = "SET_YEAR_AUTO_CITAS_SERVICIO";
export const SET_SERVICIO_CITAS_SERVICIO = "SET_SERVICIO_CITAS_SERVICIO";
export const SET_COMENTARIOS_CITAS_SERVICIO = "SET_COMENTARIOS_CITAS_SERVICIO";
export const SET_AVISO_PRIVACIDAD_CITAS_SERVICIO = "SET_AVISO_PRIVACIDAD_CITAS_SERVICIO";
export const SET_DEALER_URLS = "SET_DEALER_URLS";
export const SET_UUID_CITAS_SERVICIO = "SET_UUID_CITAS_SERVICIO";
export const SET_CITAS_DISPONIBLES_CITAS_SERVICIO = "SET_CITAS_DISPONIBLES_CITAS_SERVICIO";
export const SET_ID_CITA_CITAS_SERVICIO = "SET_ID_CITA_CITAS_SERVICIO";
export const RESET_STATE_CITAS_SERVICIO = "RESET_STATE_CITAS_SERVICIO";
export const SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO = "SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO";
export const SET_ERROR_CONSULTAR_CITAS_SERVICIO = "SET_ERROR_CONSULTAR_CITAS_SERVICIO";
export const SET_CORREO_CONTACTO_CITAS_SERVICIO = "SET_CORREO_CONTACTO_CITAS_SERVICIO";
export const SET_DEALER_HORARIOS_OFFLINE = "SET_DEALER_HORARIOS_OFFLINE";
/**
 * Types para las llamadas de Citas de servicio
 */
export const SET_LIST_ESTADOS_CITAS_SERVICIO = "SET_LIST_ESTADOS_CITAS_SERVICIO";
export const SET_LIST_CONCESIONARIOS_CITAS_SERVICIO = "SET_LIST_CONCESIONARIOS_CITAS_SERVICIO";
export const SET_LIST_MODELOS_CITAS_SERVICIO = "SET_LIST_MODELOS_CITAS_SERVICIO";
export const SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO = "SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO";


/**
 * Types para request de configurador
 */
export const SET_TRATO_CONFIGURADOR = "SET_TRATO_CONFIGURADOR"
export const SET_NOMBRE_CONFIGURADOR = "SET_NOMBRE_CONFIGURADOR"
export const SET_APELLIDO_MATERNO_CONFIGURADOR = "SET_APELLIDO_MATERNO_CONFIGURADOR"
export const SET_APELIIDO_PATERNO_CONFIGURADOR = "SET_APELIIDO_PATERNO_CONFIGURADOR"
export const SET_ESTADO_CONFIGURADOR = "SET_ESTADO_CONFIGURADOR"
export const SET_CIUDAD_CONFIGURADOR = "SET_CIUDAD_CONFIGURADOR"
export const SET_ID_CONCESIONARIO_CONFIGURADOR = "SET_ID_CONCESIONARIO_CONFIGURADOR"
export const SET_CONCESIONARIO_CONFIGURADOR = "SET_CONCESIONARIO_CONFIGURADOR"
export const SET_TELEFONO_CONFIGURADOR = "SET_TELEFONO_CONFIGURADOR"
export const SET_MOVIL_CONFIGURADOR = "SET_MOVIL_CONFIGURADOR"
export const SET_CORREO_CONFIGURADOR = "SET_CORREO_CONFIGURADOR"
export const SET_COMENTARIOS_CONFIGURADOR = "SET_COMENTARIOS_CONFIGURADOR"
export const SET_AVISO_PRIVACIDAD_CONFIGURADOR = "SET_AVISO_PRIVACIDAD_CONFIGURADOR"
export const SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR = "SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR"
export const SET_DATOS_1_CONFIGURADOR = "SET_DATOS_1_CONFIGURADOR"
export const SET_DATOS_2_CONFIGURADOR = "SET_DATOS_2_CONFIGURADOR"
export const SET_MODEL_INFO_CONFIGURADOR = "SET_MODEL_INFO_CONFIGURADOR"
export const RESET_STATE_CONFIGURADOR = "RESET_STATE_CONFIGURADOR"

/**
 * Types para request de Audi Nuevo
 */
export const SET_NOMBRE_AUDI_NUEVO = "SET_NOMBRE_AUDI_NUEVO"
export const SET_APELLIDO_MATERNO_AUDI_NUEVO = "SET_APELLIDO_MATERNO_AUDI_NUEVO"
export const SET_APELIIDO_PATERNO_AUDI_NUEVO = "SET_APELIIDO_PATERNO_AUDI_NUEVO"
export const SET_ESTADO_AUDI_NUEVO = "SET_ESTADO_AUDI_NUEVO"
export const SET_CIUDAD_AUDI_NUEVO = "SET_CIUDAD_AUDI_NUEVO"
export const SET_ID_CONCESIONARIO_AUDI_NUEVO = "SET_ID_CONCESIONARIO_AUDI_NUEVO"
export const SET_CONCESIONARIO_AUDI_NUEVO = "SET_CONCESIONARIO_AUDI_NUEVO"
export const SET_TELEFONO_AUDI_NUEVO = "SET_TELEFONO_AUDI_NUEVO"
export const SET_MOVIL_AUDI_NUEVO = "SET_MOVIL_AUDI_NUEVO"
export const SET_CORREO_AUDI_NUEVO = "SET_CORREO_AUDI_NUEVO"
export const SET_COMENTARIOS_AUDI_NUEVO = "SET_COMENTARIOS_AUDI_NUEVO"
export const SET_AVISO_PRIVACIDAD_AUDI_NUEVO = "SET_AVISO_PRIVACIDAD_AUDI_NUEVO"
export const SET_TERMINOS_Y_CONDICIONES_AUDI_NUEVO = "SET_TERMINOS_Y_CONDICIONES_AUDI_NUEVO"
export const SET_TRANSFERENCIA_DE_DATOS_AUDI_NUEVO = "SET_TRANSFERENCIA_DE_DATOS_AUDI_NUEVO"
export const SET_CONTACO_MARKETING_AUDI_NUEVO = "SET_CONTACO_MARKETING_AUDI_NUEVO"
export const SET_VEIHICULO_AUDI_NUEVO = "SET_VEIHICULO_AUDI_NUEVO"
export const SET_TIPO_CITA_AUDI_NUEVO = "SET_TIPO_CITA_AUDI_NUEVO"
export const SET_NOMBRE_DEL_VEHICULO_AUDI_NUEVO = "SET_NOMBRE_DEL_VEHICULO_AUDI_NUEVO"
export const RESET_STATE_AUDI_NUEVO = "RESET_STATE_AUDI_NUEVO"

/**
 * Types para request de Compramos tu Auto
 */
export const SET_NOMBRE_COMPRAMOS_TU_AUTO = "SET_NOMBRE_COMPRAMOS_TU_AUTO"
export const SET_APELLIDO_PATERNO_COMPRAMOS_TU_AUTO = "SET_APELIIDO_PATERNO_COMPRAMOS_TU_AUTO"
export const SET_ESTADO_COMPRAMOS_TU_AUTO = "SET_ESTADO_COMPRAMOS_TU_AUTO"
export const SET_CIUDAD_COMPRAMOS_TU_AUTO = "SET_CIUDAD_COMPRAMOS_TU_AUTO"
export const SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO = "SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO"
export const SET_CONCESIONARIO_COMPRAMOS_TU_AUTO = "SET_CONCESIONARIO_COMPRAMOS_TU_AUTO"
export const SET_TELEFONO_COMPRAMOS_TU_AUTO = "SET_TELEFONO_COMPRAMOS_TU_AUTO"
export const SET_MOVIL_COMPRAMOS_TU_AUTO = "SET_MOVIL_COMPRAMOS_TU_AUTO"
export const SET_CORREO_COMPRAMOS_TU_AUTO = "SET_CORREO_COMPRAMOS_TU_AUTO"
export const SET_COMENTARIOS_COMPRAMOS_TU_AUTO = "SET_COMENTARIOS_COMPRAMOS_TU_AUTO"
export const SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO = "SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO"
export const SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO = "SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO"
export const SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO = "SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO"
export const SET_LEGALES_COMPRAMOS_TU_AUTO = "SET_LEGALES_COMPRAMOS_TU_AUTO"
export const SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO = "SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO"
export const RESET_STATE_COMPRAMOS_TU_AUTO = "RESET_STATE_COMPRAMOS_TU_AUTO"

/**
 * Types para request de Campañas
 */
export const SET_NOMBRE_CAMPAIGN = "SET_NOMBRE_CAMPAIGN"
export const SET_APELLIDO_MATERNO_CAMPAIGN = "SET_APELLIDO_MATERNO_CAMPAIGN"
export const SET_APELIIDO_PATERNO_CAMPAIGN = "SET_APELIIDO_PATERNO_CAMPAIGN"
export const SET_ESTADO_CAMPAIGN = "SET_ESTADO_CAMPAIGN"
export const SET_CIUDAD_CAMPAIGN = "SET_CIUDAD_CAMPAIGN"
export const SET_ID_CONCESIONARIO_CAMPAIGN = "SET_ID_CONCESIONARIO_CAMPAIGN"
export const SET_CONCESIONARIO_CAMPAIGN = "SET_CONCESIONARIO_CAMPAIGN"
export const SET_TELEFONO_CAMPAIGN = "SET_TELEFONO_CAMPAIGN"
export const SET_MOVIL_CAMPAIGN = "SET_MOVIL_CAMPAIGN"
export const SET_CORREO_CAMPAIGN = "SET_CORREO_CAMPAIGN"
export const SET_COMENTARIOS_CAMPAIGN = "SET_COMENTARIOS_CAMPAIGN"
export const SET_AVISO_PRIVACIDAD_CAMPAIGN = "SET_AVISO_PRIVACIDAD_CAMPAIGN"
export const SET_TERMINOS_Y_CONDICIONES_CAMPAIGN = "SET_TERMINOS_Y_CONDICIONES_CAMPAIGN"
export const SET_TRANSFERENCIA_DE_DATOS_CAMPAIGN = "SET_TRANSFERENCIA_DE_DATOS_CAMPAIGN"
export const SET_CONTACO_MARKETING_CAMPAIGN = "SET_CONTACO_MARKETING_CAMPAIGN"
export const SET_VEIHICULO_CAMPAIGN = "SET_VEIHICULO_CAMPAIGN"
export const SET_TIPO_CITA_CAMPAIGN = "SET_TIPO_CITA_CAMPAIGN"
export const SET_NOMBRE_DEL_VEHICULO_CAMPAIGN = "SET_NOMBRE_DEL_VEHICULO_CAMPAIGN"
export const RESET_STATE_CAMPAIGN = "RESET_STATE_CAMPAIGN"

/**
 * Types para request de Prueba de manejo
 */
export const SET_NOMBRE_PRUEBA_DE_MANEJO = "SET_NOMBRE_PRUEBA_DE_MANEJO"
export const SET_APELLIDO_PATERNO_PRUEBA_DE_MANEJO = "SET_APELIIDO_PATERNO_PRUEBA_DE_MANEJO"
export const SET_ESTADO_PRUEBA_DE_MANEJO = "SET_ESTADO_PRUEBA_DE_MANEJO"
export const SET_CIUDAD_PRUEBA_DE_MANEJO = "SET_CIUDAD_PRUEBA_DE_MANEJO"
export const SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO = "SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO"
export const SET_CONCESIONARIO_PRUEBA_DE_MANEJO = "SET_CONCESIONARIO_PRUEBA_DE_MANEJO"
export const SET_TELEFONO_PRUEBA_DE_MANEJO = "SET_TELEFONO_PRUEBA_DE_MANEJO"
export const SET_MOVIL_PRUEBA_DE_MANEJO = "SET_MOVIL_PRUEBA_DE_MANEJO"
export const SET_CORREO_PRUEBA_DE_MANEJO = "SET_CORREO_PRUEBA_DE_MANEJO"
export const SET_COMENTARIOS_PRUEBA_DE_MANEJO = "SET_COMENTARIOS_PRUEBA_DE_MANEJO"
export const SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO = "SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO"
export const SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO = "SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO"
export const SET_VEHICULO_INTERES_PRUEBA_DE_MANEJO = "SET_KILOMETRAJE_DEL_VEHICULO_PRUEBA_DE_MANEJO"
export const SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO = "SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO"
export const SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO = "SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO"
export const RESET_STATE_PRUEBA_DE_MANEJO = "RESET_STATE_PRUEBA_DE_MANEJO"

/**
 * Types para request de Contacto
 */
export const SET_NOMBRE_CONTACTO = "SET_NOMBRE_CONTACTO"
export const SET_APELLIDO_MATERNO_CONTACTO = "SET_APELLIDO_MATERNO_CONTACTO"
export const SET_APELIIDO_PATERNO_CONTACTO = "SET_APELIIDO_PATERNO_CONTACTO"
export const SET_ESTADO_CONTACTO = "SET_ESTADO_CONTACTO"
export const SET_CIUDAD_CONTACTO = "SET_CIUDAD_CONTACTO"
export const SET_ID_CONCESIONARIO_CONTACTO = "SET_ID_CONCESIONARIO_CONTACTO"
export const SET_CONCESIONARIO_CONTACTO = "SET_CONCESIONARIO_CONTACTO"
export const SET_TELEFONO_CONTACTO = "SET_TELEFONO_CONTACTO"
export const SET_MOVIL_CONTACTO = "SET_MOVIL_CONTACTO"
export const SET_CORREO_CONTACTO = "SET_CORREO_CONTACTO"
export const SET_COMENTARIOS_CONTACTO = "SET_COMENTARIOS_CONTACTO"
export const SET_AVISO_PRIVACIDAD_CONTACTO = "SET_AVISO_PRIVACIDAD_CONTACTO"
export const SET_TERMINOS_Y_CONDICIONES_CONTACTO = "SET_TERMINOS_Y_CONDICIONES_CONTACTO"
export const SET_TRANSFERENCIA_DE_DATOS_CONTACTO = "SET_TRANSFERENCIA_DE_DATOS_CONTACTO"
export const SET_CONTACO_MARKETING_CONTACTO = "SET_CONTACO_MARKETING_CONTACTO"
export const SET_VEIHICULO_CONTACTO = "SET_VEIHICULO_CONTACTO"
export const SET_TIPO_CITA_CONTACTO = "SET_TIPO_CITA_CONTACTO"
export const SET_NOMBRE_DEL_VEHICULO_CONTACTO = "SET_NOMBRE_DEL_VEHICULO_CONTACTO"
export const SET_VIN_CONTACTO = "SET_VIN_CONTACTO"
export const RESET_STATE_CONTACTO = "RESET_STATE_CONTACTO"

/* Types para request de VTP Nuevo
*/
export const SET_NOMBRE_VTP_NUEVOS = "SET_NOMBRE_VTP_NUEVOS"
export const SET_APELLIDO_MATERNO_VTP_NUEVOS = "SET_APELLIDO_MATERNO_VTP_NUEVOS"
export const SET_APELIIDO_PATERNO_VTP_NUEVOS = "SET_APELIIDO_PATERNO_VTP_NUEVOS"
export const SET_ESTADO_VTP_NUEVOS = "SET_ESTADO_VTP_NUEVOS"
export const SET_CIUDAD_VTP_NUEVOS = "SET_CIUDAD_VTP_NUEVOS"
export const SET_ID_CONCESIONARIO_VTP_NUEVOS = "SET_ID_CONCESIONARIO_VTP_NUEVOS"
export const SET_CONCESIONARIO_VTP_NUEVOS = "SET_CONCESIONARIO_VTP_NUEVOS"
export const SET_TELEFONO_VTP_NUEVOS = "SET_TELEFONO_VTP_NUEVOS"
export const SET_MOVIL_VTP_NUEVOS = "SET_MOVIL_VTP_NUEVOS"
export const SET_CORREO_VTP_NUEVOS = "SET_CORREO_VTP_NUEVOS"
export const SET_COMENTARIOS_VTP_NUEVOS = "SET_COMENTARIOS_VTP_NUEVOS"
export const SET_AVISO_PRIVACIDAD_VTP_NUEVOS = "SET_AVISO_PRIVACIDAD_VTP_NUEVOS"
export const SET_TERMINOS_Y_CONDICIONES_VTP_NUEVOS = "SET_TERMINOS_Y_CONDICIONES_VTP_NUEVOS"
export const SET_TRANSFERENCIA_DE_DATOS_VTP_NUEVOS = "SET_TRANSFERENCIA_DE_DATOS_VTP_NUEVOS"
export const SET_CONTACO_MARKETING_VTP_NUEVOS = "SET_CONTACO_MARKETING_VTP_NUEVOS"
export const SET_VEIHICULO_VTP_NUEVOS = "SET_VEIHICULO_VTP_NUEVOS"
export const SET_TIPO_CITA_VTP_NUEVOS = "SET_TIPO_CITA_VTP_NUEVOS"
export const SET_NOMBRE_DEL_VEHICULO_VTP_NUEVOS = "SET_NOMBRE_DEL_VEHICULO_VTP_NUEVOS"
export const RESET_STATE_VTP_NUEVOS = "RESET_STATE_VTP_NUEVOS"

/**
 * Types para request de VTP Usados
 */
export const SET_NOMBRE_VTP_USADOS = "SET_NOMBRE_VTP_USADOS"
export const SET_APELLIDO_MATERNO_VTP_USADOS = "SET_APELLIDO_MATERNO_VTP_USADOS"
export const SET_APELIIDO_PATERNO_VTP_USADOS = "SET_APELIIDO_PATERNO_VTP_USADOS"
export const SET_ESTADO_VTP_USADOS = "SET_ESTADO_VTP_USADOS"
export const SET_CIUDAD_VTP_USADOS = "SET_CIUDAD_VTP_USADOS"
export const SET_ID_CONCESIONARIO_VTP_USADOS = "SET_ID_CONCESIONARIO_VTP_USADOS"
export const SET_CONCESIONARIO_VTP_USADOS = "SET_CONCESIONARIO_VTP_USADOS"
export const SET_TELEFONO_VTP_USADOS = "SET_TELEFONO_VTP_USADOS"
export const SET_MOVIL_VTP_USADOS = "SET_MOVIL_VTP_USADOS"
export const SET_CORREO_VTP_USADOS = "SET_CORREO_VTP_USADOS"
export const SET_COMENTARIOS_VTP_USADOS = "SET_COMENTARIOS_VTP_USADOS"
export const SET_AVISO_PRIVACIDAD_VTP_USADOS = "SET_AVISO_PRIVACIDAD_VTP_USADOS"
export const SET_TERMINOS_Y_CONDICIONES_VTP_USADOS = "SET_TERMINOS_Y_CONDICIONES_VTP_USADOS"
export const SET_TRANSFERENCIA_DE_DATOS_VTP_USADOS = "SET_TRANSFERENCIA_DE_DATOS_VTP_USADOS"
export const SET_CONTACO_MARKETING_VTP_USADOS = "SET_CONTACO_MARKETING_VTP_USADOS"
export const SET_VEIHICULO_VTP_USADOS = "SET_VEIHICULO_VTP_USADOS"
export const SET_TIPO_CITA_VTP_USADOS = "SET_TIPO_CITA_VTP_USADOS"
export const SET_NOMBRE_DEL_VEHICULO_VTP_USADOS = "SET_NOMBRE_DEL_VEHICULO_VTP_USADOS"
export const RESET_STATE_VTP_USADOS = "RESET_STATE_VTP_USADOS"

/**
 * Types para request de Accesorios / collection
 */

export const SET_NUMERO_DE_PARTE_ACCESORIOS = "SET_NUMERO_DE_PARTE_ACCESORIOS"
